import { render, staticRenderFns } from "./APropos.vue?vue&type=template&id=4d1b0feb&"
import script from "./APropos.vue?vue&type=script&lang=js&"
export * from "./APropos.vue?vue&type=script&lang=js&"
import style0 from "./APropos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports